<style scoped>

</style>
<style  scoped="scoped">
@import '../../../../assets/css/common.css';
</style>
<style type="text/css">
	.mobiledeveloper .el-menu-item{
		height: 45px;
		line-height: 45px;
		border-bottom: 1px solid #2F3757;
	}
	.mobiledeveloper .el-container .el-menu{
  	border-right: none;
  }

</style>
<template>
  <div class="mobiledeveloper">
		<header class="mobilehead">
			<el-row>
				<el-col :span="4"><div style="padding-left:8px" @click="clickLogin"><img src="../../../../assets/images/icon/back.png" /></div></el-col>
				<el-col :span="16"><div class="tlc">开发者</div></el-col>
				<el-col :span="4">
					<div @click="menulist = !menulist">
						<img src="../../../../assets/images/icon/mobilemenu.png" v-if="!menulist"/>
						<img src="../../../../assets/images/icon/mobileclose.png" v-if="menulist"/>
					</div>
				</el-col>
			</el-row>
		</header>
		<div class="menulist" v-if="menulist" @touchmove.prevent>
			<el-menu
					:default-active="pagedefault"
					router
					class="developer-menu">
					<el-menu-item index="/front/Mobilehome/developer/detail" @click="menulist = false">
						<span slot="title">资源接口权限</span>
					</el-menu-item>
						<el-submenu index="/front/Mobilehome/developer/summary">
							<template slot="title">
								<span>接口调用统计</span>
							</template>
								<el-menu-item :index="'/front/Mobilehome/developer/summary?name='+encodeURI(item.name)" v-for="item in menus" :key="item.id" @click="menulist = false" >{{item.name}}</el-menu-item>
						</el-submenu>
				</el-menu>
		</div>
		<div v-if="menulist" @click="menulist = !menulist" class="menulist-mask" @touchmove.prevent></div>
		<el-main class="content-wrapper">
			<router-view></router-view>
		</el-main>
  </div>
</template>
<script type="text/babel">
import commonService from '@/service/commonService'
import detailService from '@/service/front/detailService'
import {mapGetters, mapActions} from 'vuex'
export default {
  data: function () {
    return {
      menus: [],
      pagedefault: '/front/Mobilehome/developer/detail',
      menulist: false
    }
  },
  name: 'mobiledeveloper',
  computed: {
    ...mapGetters(['userinfo', 'devdefaultvx'])
  },
  watch: {
    devdefaultvx (newVal, oldVal) {
      this.pagedefault = newVal
      this.menulist = false
    },
    $route () {
      if (!this.userinfo.clientId) {
        this.$router.push({path: '/front/Mobilehome/mobileLogin'})
      } else {
        if (this.$route.path) {
        // 实现路由切换
          this.pagedefault = this.$route.fullPath
          // console.log(this.$route)
          this.menulist = false
        }
      }
    }
  },
  mounted () {
    // 判断是否已经登录
    if (!this.userinfo.clientId) {
      this.$router.push({path: '/front/Mobilehome/mobileLogin'})
    } else {
      // 实现路由切换
      this.$router.push({path: this.pagedefault})
    }
    this.initMenu()
  },
  methods: {
    async initMenu () {
      try {
        let data = await detailService.fetchDetail()
        if (data && data.resourcePermissionList) {
          let _temps = []
          for (let item of data.resourcePermissionList) {
            _temps.push({
              id: item.apiResourceDto.id,
              name: item.apiResourceDto.name
            })
          }
          this.menus = _temps
          // console.log(data)
        } else {
          this.menus = []
        }
      } catch (e) {
        this.$message.error({
          message: e && e.msg,
          customClass: 'errmsg'
        })
      }
    },
    clickLogin () {
      this.pagedefault = ''
      this.$router.push({name: 'fronthome'})
      this.$nextTick(() => {
        this.pagedefault = '/'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/front/mobile-page/mobiledeveloper/index.vue